import { toolFailure, type AgentTool, type AgentToolPreview } from './agent-tool';

export type Confirm = (preview: AgentToolPreview) => Promise<boolean>;

export function requireConfirmation(tool: AgentTool, confirm: Confirm | null, declined: string): AgentTool | null {
  if (tool.readOnly) return tool;
  const { preview } = tool;
  if (!preview || !confirm) return null;
  return {
    ...tool,
    execute: async (input) => {
      const confirmed = await confirm(await preview(input));
      return confirmed ? tool.execute(input) : toolFailure(declined);
    },
  };
}
